export default {
    DOSAGEM_PROTEINURIA: 1,
    GRAVIDEZ: 2,
    HEPATITE_C: 3,
    HIV: 4,
    SIFILIS: 5,
    HEPATITE_B: 6,
}